
export function angularMaterialConfig($mdGestureProvider) {
    'ngInject';

    //-- click hijacking is used to prevent random click events 
    //-- after tapping on old mobile browsers
    //-- this prevents browser native audio controls from being tapped
    $mdGestureProvider.skipClickHijack()
}
